import Type from './Type';
export function isICarousel(node) {
    return node.type === Type.Carousel;
}
export default isICarousel;    //# sourceMappingURL=isICarousel.js.map
